import {ChangeDetectionStrategy, Component, computed, input, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {SelectButton} from 'primeng/selectbutton';
import {TranslocoPipe} from '@jsverse/transloco';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {weightBarColor, weightBarWidth} from '../../../../../../../shared/charts/weight-bar.util';
import {RankingRowX} from '../../evaluation-criteria-x.types';
import {WeightBarX, WeightingSummaryViewX} from './weighting-summary-x.types';

@Component({
  selector: 'app-weighting-summary-x',
  imports: [FormsModule, SelectButton, TranslocoPipe, TranslateDirectusPipe],
  templateUrl: './weighting-summary-x.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WeightingSummaryXComponent {
  readonly title = input.required<string>();
  readonly testId = input.required<string>();
  readonly ranking = input<RankingRowX[]>([]);

  protected readonly view = signal<WeightingSummaryViewX>('table');

  protected readonly viewOptions = [
    {value: 'table', translationKey: 'project.steps.viewTable', icon: 'pi pi-table'},
    {value: 'chart', translationKey: 'project.steps.viewChart', icon: 'pi pi-chart-bar'},
  ];

  protected readonly showsTable = computed<boolean>(() => this.view() === 'table');

  protected readonly sortedRanking = computed<RankingRowX[]>(() =>
    [...this.ranking()].sort((first, second) => second.percentage - first.percentage),
  );

  private readonly highestPercentage = computed<number>(
    () => this.sortedRanking()[0]?.percentage ?? 0,
  );

  protected readonly weightBars = computed<WeightBarX[]>(() => {
    const highestPercentage = this.highestPercentage();

    return this.sortedRanking().map((row) => ({
      ...row,
      color: weightBarColor(row.percentage, highestPercentage),
      width: weightBarWidth(row.percentage, highestPercentage),
    }));
  });
}
